/**
 * Defines the events associated with the CompletionBar component.
 */
export const CompletionBarEvents = {
  SEE_MORE_CLICKED: 'lua-completion-bar:see-more-clicked',
} as const;
